module.exports = __webpack_public_path__ + "static/media/it-small.225fdbff.svg";